export default __webpack_public_path__ + "static/media/block.daf05bed.svg";